import React from 'react';
import HotelCard from './HotelCard';

const HotelList = ({ hotels }) => {
  return (
    <>
      {hotels.map((hotel, index) => (
        <HotelCard 
          key={index} 
          hotel={hotel} 
          reverse={index % 2 !== 0}
        />
      ))}
    </>
  );
};

export default HotelList;